<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiLockOpenOutline } from "@mdi/js";
export default {
  name: "MdiLockOpenOutline",
  data() {
    return {
      svgPath: mdiLockOpenOutline,
    };
  },
};
</script>
